import React from 'react'
import './ConfirmationInfo.css'

function ConfirmationInfoOEW(props) {
  return (
    <>
          <tr>
            <td className='td-title-text'>
              <span className='title-text'>LotNumber #: </span>
              <span className='info-text'>
                {props?.confirmationData?.fileLotNumber}
              </span>
            </td>
          </tr>
        <tr>
            <td className='td-title-text'>
              <span className='title-text'>File No #: </span>
              <span className='info-text'>
               {props?.confirmationData?.fileNo}
              </span>
            </td>
          </tr>
          <tr>
            <td className='td-title-text'>
              <span className='title-text'>Booking No: </span>
              <span className='info-text'>
                {props?.confirmationData?.bookingNo}{' '}
              </span>
            </td>
          </tr>
          <tr>
            <td className='td-title-text'>
              <span className='title-text'>MBL: </span>
              <span className='info-text'>
                {props?.confirmationData?.masterBillNumber}
              </span>
            </td>
          </tr>
          

    </>
  )
}

export default ConfirmationInfoOEW
